import apiClient from "@/utils/httpClient";
import type { CreateIntercompanyTagDto, UpdateIntercompanyTagDto, IntercompanyTagDto } from "@blinkbooks/types";

export const listIntercompanyTags = (): Promise<IntercompanyTagDto[]> =>
  apiClient.get<IntercompanyTagDto[]>("/intercompany-tags");

export const createIntercompanyTag = (data: CreateIntercompanyTagDto): Promise<IntercompanyTagDto> =>
  apiClient.post<IntercompanyTagDto>("/intercompany-tags", data);

/** Resolves an existing tag: assign it to a company, or move it back to ignored. */
export const updateIntercompanyTag = (id: string, data: UpdateIntercompanyTagDto): Promise<IntercompanyTagDto> =>
  apiClient.patch<IntercompanyTagDto>(`/intercompany-tags/${id}`, data);

export const deleteIntercompanyTag = (id: string): Promise<void> =>
  apiClient.delete(`/intercompany-tags/${id}`);
